import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath, Rect } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SVGComponent = (props) => (
  <Svg
    width={props.size || 36}
    height={props.size || 36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle cx={18} cy={18} r={18} fill={props.bgColor || "#E7F4ED"} />
    <G clipPath="url(#clip0_9022_8898)">
      <G filter="url(#filter0_d_9022_8898)">
        <Path
          d="M13.834 10.8333V18.3333C13.834 18.7917 14.209 19.1667 14.6673 19.1667H16.334V25.125C16.334 25.55 16.8923 25.7 17.109 25.3333L21.434 17.9167C21.759 17.3583 21.359 16.6667 20.7173 16.6667H18.834L20.909 11.125C21.1173 10.5833 20.7173 10 20.134 10H14.6673C14.209 10 13.834 10.375 13.834 10.8333Z"
          fill={props.color || "#109648"}
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_9022_8898">
        <Rect width={20} height={20} fill="white" transform="translate(8 8)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
